
const About = () => {
  return (
    <section id="apropos" className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          {/* Titre */}
          <h2 className="text-4xl md:text-5xl font-bold text-gray-300 mb-8" style={{ fontFamily: 'Alice, serif' }}>
            À Propos
          </h2>
          
          {/* Ligne décorative */}
          <div className="flex items-center justify-center mb-12">
            <div className="w-24 h-px bg-gray-300"></div>
            <div className="w-4 h-4 bg-gray-300 rounded-full mx-6 rotate-45"></div>
            <div className="w-24 h-px bg-gray-300"></div>
          </div>

          {/* Contenu centré */}
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-6" style={{ fontFamily: 'Alice, serif' }}>
              Une Passion, Un Art, Une Excellence
            </h3>
            
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              Depuis plus de 15 ans, <strong className="text-gray-300">L'Art des Mets – Paris</strong>, 
              sublime vos événements les plus prestigieux avec une cuisine d'exception et un service irréprochable.
            </p>
            
            <p className="text-gray-300 text-lg leading-relaxed mb-8">
              Notre philosophie repose sur l'alliance parfaite entre tradition culinaire française et innovation 
              contemporaine, créant des expériences gustatives mémorables pour chaque occasion.
            </p>

            <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
              <div className="flex items-center justify-center md:justify-start">
                <div className="w-2 h-2 bg-gray-300 rounded-full mr-4"></div>
                <span className="text-white">Cuisine du monde fusion</span>
              </div>
              <div className="flex items-center justify-center md:justify-start">
                <div className="w-2 h-2 bg-gray-300 rounded-full mr-4"></div>
                <span className="text-white">Produits nobles revisités</span>
              </div>
              <div className="flex items-center justify-center md:justify-start">
                <div className="w-2 h-2 bg-gray-300 rounded-full mr-4"></div>
                <span className="text-white">Création d'évènements sur mesure</span>
              </div>
              <div className="flex items-center justify-center md:justify-start">
                <div className="w-2 h-2 bg-gray-300 rounded-full mr-4"></div>
                <span className="text-white">Personnel de service expérimenté</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
